<section class="our-portfolio" style="direction: ltr;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <img src="./../../../assets/images/our-offers.png" alt="" class="section-title" style="width: 200px;" />
            </div>

            <div class="col-md-12">
                <ngx-slick-carousel 
                    class="carousel" 
                    style="padding-bottom: 10px;"
                    #slickModal="slick-carousel" 
                    [config]="slideConfig"
                    *ngIf="isData">
                    <div ngxSlickItem *ngFor="let work of works; let i = index" class="slide">
                        <div class="wrapper">
                            <img src="https://www.admin.codesroots.com/library/homepage/photo/umphotos/{{work.photo}}" alt="{{work.name}}" />
                            <h4 class="text-center">
                                {{work.name}}
                            </h4>
                        </div>                     
                    </div>
                </ngx-slick-carousel> 
            </div>

            <!--<div class="col-md-3" *ngFor="let work of works; let i = index">
                <div class="wrapper">
                    <a routerLink="/تفاصيل" (click)="setIndex(i)">
                        <img src="https://www.codesroots.com/library/homepage/photo/umphotos/{{work.photo}}" alt="{{work.name}}" />
                        <h4 class="text-center">
                            {{work.name}}
                        </h4>
                    </a>
                </div>                
            </div>-->
        </div>
    </div>
</section>

<section class="our-portfolio-description" style="direction: ltr; margin-bottom: 0;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <ngx-slick-carousel 
                    class="carousel-desc" 
                    #slickModal="slick-carousel" 
                    [config]="slideConfigDesc">
                    <div ngxSlickItem *ngFor="let work of works" class="slide-desc">
                        <div class="wrapper">
                            <div class="portfolio-description text-center">
                                <h3 class="inner-title" style="font-weight: bold;">{{work.name}}</h3>
                                <p>{{work.description}}</p>
                                <p  class="full-desc-list" [innerHTML]="work.full_desc"></p>
                                <div class="portfolio-img text-center">
                                    <img src="https://www.admin.codesroots.com/library/homepage/photo/umphotos/{{work.inside_photo}}" alt="{{work.name}}" />
                                </div>                                 
                                <div class="btns">
                                    <div class="stors">
                                        <a href="{{work.android_link}}" target="_blank">
                                            <img src="./../../../../assets/images/google-play.png" alt="" />
                                        </a>
                                        <a href="{{work.ios_link}}" target="_blank">
                                            <img src="./../../../../assets/images/app-store.png" alt="" />
                                        </a>                                
                                    </div>
                                    <a routerLink="/تواصل-معنا" class="btn-contact" matRipple>تواصل معنا الان</a>
                                </div>
                            </div>                                       
                        </div>
                    </div>                    
                </ngx-slick-carousel> 
            </div>  

            <!--<div class="col-md-6" *ngFor="let work of works">
                <div class="wrapper">
                    <div class="portfolio-description text-center">
                        <h3 class="inner-title" style="font-weight: bold;">{{work.name}}</h3>
                        <p>{{work.description}}</p>
                        <div class="btns">
                            <div class="stors">
                                <a href="{{work.android_link}}" target="_blank">
                                    <img src="./../../../../assets/images/google-play.png" alt="" />
                                </a>
                                <a href="{{work.ios_link}}" target="_blank">
                                    <img src="./../../../../assets/images/app-store.png" alt="" />
                                </a>                                
                            </div>
                            <a routerLink="/تواصل-معنا" class="btn-contact" matRipple>تواصل معنا الان</a>
                        </div>
                    </div>
                    <div class="portfolio-img text-center">
                        <img src="https://www.codesroots.com/library/homepage/photo/umphotos/{{work.inside_photo}}" alt="{{work.name}}" />
                    </div>                                        
                </div>                
            </div>-->
        </div>
    </div>
</section>